// ============================================================
// Fuente única de verdad para navegación y acceso por rol.
// La consumen: SidebarGeneral.vue, router/index.js, Login.vue
// y useAuthStore. Agrega aquí nuevos módulos/roles sin tocar
// esos archivos.
// ============================================================

export const NAV_CONFIG = {
  sections: [
    {
      key: "tablero",
      label: "Producción",
      items: [
        {
          tab: "estadisticas",
          label: "Estadísticas",
          icon: "bi-bar-chart",
          subItems: [
            { tab: "consumo_mp", label: "Consumo Materia Prima", icon: "bi-boxes" },
            { tab: "stats_vena_scrap", label: "Vena y Scrap", icon: "bi-graph-up" },
            { tab: "scrap_almacen", label: "Scrap Almacén y Láser", icon: "bi-recycle" },
          ],
        },
      ],
    },
    {
      key: "procesos",
      label: "Procesos",
      items: [
        { tab: "eventos", label: "Mantenimientos", icon: "bi-tools" },
        { tab: "moldes", label: "Moldes", icon: "bi-box-seam" },
        { tab: "tipos", label: "Tipos de evento", icon: "bi-tags" },
      ],
    },
    {
      key: "inventario",
      label: "CP&L",
      items: [
        { tab: "inventario", label: "Inventario", icon: "bi-boxes" },
        {
          tab: "formularios",
          label: "Formularios",
          icon: "bi-card-list",
          subItems: [
            { tab: "consumo_materia_prima", label: "Materia Prima", icon: "bi-box-seam-fill" },
            { tab: "scrap_almacen_laser", label: "Scrap Almacén y Láser", icon: "bi-exclamation-triangle-fill" },
            { tab: "vena_scrap", label: "Vena y Scrap", icon: "bi-layers-fill" },
          ],
        },
        {
          tab: "catalogos",
          label: "Catálogos",
          icon: "bi-stack",
          subItems: [
            // { tab: "cat_productos", label: "Productos", icon: "bi-box" },
            { tab: "cat_maquinas", label: "Inyectoras", icon: "bi-gear" },
            { tab: "operadores", label: "Operadores", icon: "bi-person" },
            { tab: "pigmentos", label: "Pigmentos", icon: "bi-palette" },
            { tab: "tpus", label: "TPUs", icon: "bi-tag" },
            { tab: "codigos_defectos", label: "Defectos", icon: "bi-x-octagon" },
          ],
        },
      ],
    },
    {
      key: "pedidos",
      label: "Ventas",
      items: [
        { tab: "clientes", label: "Clientes", icon: "bi-people" },
        { tab: "articulos", label: "Artículos", icon: "bi-gem" },
        { tab: "pedidos", label: "Pedidos", icon: "bi-receipt" },
        { tab: "disenos", label: "Diseños", icon: "bi-vector-pen" },
      ],
    },
    {
      key: "almacen",
      label: "Almacén",
      items: [
        {
          tab: "pedidos_almacen",
          label: "Pedidos asignados",
          icon: "bi-clipboard-check",
        },
      ],
    },
    {
      key: "inyeccion",
      label: "Inyección",
      items: [
        {
          tab: "reporte_produccion",
          label: "Reporte de producción",
          // Título más corto para el navbar móvil (AdminLayout.vue lo
          // muestra centrado ahí; el sidebar de escritorio sigue usando `label`).
          mobileLabel: "Producción",
          icon: "bi-clipboard-data",
        },
      ],
    },

    // ── Mantenimiento industrial ────────────────────────────
    {
      key: "mantenimiento_ops",
      label: "Mantenimiento",
      items: [
        { tab: "maquinas", label: "Máquinas", icon: "bi-gear-wide-connected" },
        { tab: "actividades", label: "Actividades", icon: "bi-list-check" },
        { tab: "rutinas", label: "Rutinas", icon: "bi-arrow-repeat" },
        { tab: "refacciones", label: "Refacciones", icon: "bi-box2" },
        { tab: "calendario", label: "Calendario", icon: "bi-calendar3" },
        { tab: "mtto_preventivo", label: "Mtto. preventivo", icon: "bi-shield-check" },
        {
          tab: "mtto_correctivo",
          label: "Mtto. correctivo",
          icon: "bi-wrench-adjustable",
        },
      ],
    },

    // ── Inventario de activos ─────────────────────────────
    {
      key: "inventario_activos",
      label: "Activos",
      items: [
        { tab: "areas_trabajo", label: "Áreas de trabajo", icon: "bi-map" },
        { tab: "activos_categorias", label: "Categorías", icon: "bi-tags" },
        { tab: "activos_fijos", label: "Activos fijos", icon: "bi-building-gear" },
      ],
    },
  ],

  roleAccess: {
    superadmin: [
      "procesos",
      "inventario",
      "pedidos",
      "almacen",
      "tablero",
      "maquinas",
      "mantenimiento_ops",
      "inventario_activos",
      "inyeccion",
    ],
    business_owner: [
      "procesos",
      "inventario",
      "pedidos",
      "almacen",
      "tablero",
      "maquinas",
      "mantenimiento_ops",
      "inventario_activos",
      "inyeccion",
    ],
    produccion_materiales: ["inventario"],
    procesos: ["procesos"],
    gestion_pedidos: ["pedidos"],
    // Brenda: además de sus pedidos, confirma/aprueba los reportes de
    // producción que da de alta Nico (responsable_inyeccion).
    // responsable_almacen: ["almacen", "inyeccion"],
    responsable_almacen: ["almacen"],
    responsable_laser: ["almacen"],
    mantenimientos: ["maquinas", "mantenimiento_ops"],
    // Nico: da de alta los reportes de producción de Inyección.
    responsable_inyeccion: ["inyeccion"],
    user: [],
  },

  roleLabels: {
    superadmin: "Superadmin",
    business_owner: "Business Owner",
    produccion_materiales: "Producción y Materiales",
    procesos: "Procesos y Calidad",
    gestion_pedidos: "Gestión de Pedidos",
    responsable_almacen: "Responsable de Almacén",
    responsable_laser: "Líder de Láser",
    mantenimientos: "Mantenimientos y Máquinas",
    responsable_inyeccion: "Responsable de Inyección",
    user: "Usuario",
  },
};

// ── Mapa rol → ruta de inicio ────────────────────────────────
export const ROLE_HOME = {
  superadmin: "/admin/general",
  business_owner: "/admin/general",
  produccion_materiales: "/admin/produccion",
  procesos: "/admin/procesos",
  gestion_pedidos: "/admin/pedidos",
  responsable_almacen: "/admin/pedidos-seguimiento",
  responsable_laser: "/admin/pedidos-laser",
  mantenimientos: "/admin/maquinas",
  responsable_inyeccion: "/admin/inyeccion",
};

// ── Roles con acceso total (no se bloquean por meta.role) ───
export const FULL_ACCESS_ROLES = ["superadmin", "business_owner"];
